export const FormMixin = {
    methods: {
        // Método para validar o formulário
        validateState: function(prefix ="") {
            let arValidation = [];

            for (let ref in this.$refs) {
                if(!ref.includes(prefix)) continue;

                if(this.$refs[ref] == undefined) continue;

                if(this.$refs[ref].length == 0 || this.$refs[ref].length == undefined) {
                    try{
                        arValidation.push(this.$refs[ref].valid());
                    } catch(e) {
                        console.error('Campo não encontrado: ', ref);
                    }
                }else{
                    for(let i = 0; i < this.$refs[ref].length; i++){
                        arValidation.push(this.$refs[ref][i].valid());
                    }
                }
            }
           
            return arValidation.filter((elem) => elem == false).length == 0;
        },
        // Método para validar o formulário REFATORAR NOMES NAS OUTRAS TELAS E APOS ISSO REMOVER CODIGO ACIMA
        validarFormulario: function(prefix = "", retornarObjeto = false) {
            let arValidation = [];
            let camposInvalidos = [];

            for (let ref in this.$refs) {
                if(!ref.includes(prefix)) continue;

                if(this.$refs[ref] == undefined) continue;

                if(this.$refs[ref].length == 0 || this.$refs[ref].length == undefined) {
                    try{
                        arValidation.push(this.$refs[ref].valid());
                        if(!this.$refs[ref].valid())
                            camposInvalidos.push(ref);
                    } catch(e) {
                        console.error('Campo não encontrado: ', ref);
                    }
                }else{
                    for(let i = 0; i < this.$refs[ref].length; i++){
                        arValidation.push(this.$refs[ref][i].valid());
                        if(!this.$refs[ref][i].valid())
                            camposInvalidos.push(ref);
                    }
                }
            }
        
            if(retornarObjeto){
                return {
                    valido : arValidation.filter((elem) => elem == false).length == 0,
                    campos : camposInvalidos                     
                }
            }
        return arValidation.filter((elem) => elem == false).length == 0;
        },
        limparFormulario: function(prefix ="") {

            for (let ref in this.$refs) {
                if(!ref.includes(prefix)) continue;

                if(this.$refs[ref] == undefined) continue;

                if(this.$refs[ref].length == 0 || this.$refs[ref].length == undefined) {
                    try{
                        this.$refs[ref].clear();
                    } catch(e) {
                        console.error('Campo não encontrado: ', ref);
                    }
                }else{
                    for(let i = 0; i < this.$refs[ref].length; i++){
                        this.$refs[ref][i].clear();
                    }
                }
            }
           
        },
    },
}